import { web_url } from "../config";

// Preset icons admins pick from for deal badges / amenities. The files live in
// the website's public folder (web/public/deals/park-grandeur), so the saved
// value is a site-relative path the website can render as-is.
const DIR = "/deals/park-grandeur";

export const DEAL_ICONS = [
  ["icon-bolt", "Bolt"],
  ["icon-verified", "Verified"],
  ["icon-shield", "Shield"],
  ["icon-lock", "Lock"],
  ["icon-check", "Check"],
  ["icon-tick", "Tick"],
  ["icon-rera", "RERA"],
  ["icon-savings", "Savings"],
  ["icon-trend-down", "Trend down"],
  ["icon-alarm", "Alarm"],
  ["icon-hourglass", "Hourglass"],
  ["icon-calendar", "Calendar"],
  ["icon-pin", "Location"],
  ["icon-doc", "Document"],
  ["amenity-pool", "Pool"],
  ["amenity-gym", "Gym"],
  ["amenity-concierge", "Concierge"],
  ["amenity-spa", "Spa"],
  ["amenity-jacuzzi", "Jacuzzi"],
  ["amenity-clubhouse", "Clubhouse"],
  ["amenity-garden", "Garden"],
  ["amenity-park", "Park"],
  ["amenity-kids-play", "Kids play area"],
  ["amenity-jogging", "Jogging track"],
  ["amenity-yoga", "Yoga & meditation"],
  ["amenity-tennis", "Tennis court"],
  ["amenity-basketball", "Sports court"],
  ["amenity-football", "Football"],
  ["amenity-golf", "Golf"],
  ["amenity-indoor-games", "Indoor games"],
  ["amenity-theatre", "Theatre"],
  ["amenity-party-hall", "Party hall"],
  ["amenity-restaurant", "Restaurant"],
  ["amenity-cafe", "Café"],
  ["amenity-bar", "Bar & lounge"],
  ["amenity-bbq", "Barbecue"],
  ["amenity-library", "Library"],
  ["amenity-business-centre", "Business centre"],
  ["amenity-coworking", "Co-working"],
  ["amenity-wifi", "Wi-Fi"],
  ["amenity-lift", "Lift"],
  ["amenity-parking", "Parking"],
  ["amenity-ev-charging", "EV charging"],
  ["amenity-security", "24x7 security"],
  ["amenity-cctv", "CCTV"],
  ["amenity-gated", "Gated community"],
  ["amenity-power-backup", "Power backup"],
  ["amenity-fire-safety", "Fire safety"],
  ["amenity-water", "Water supply"],
  ["amenity-ac", "Air conditioning"],
  ["amenity-laundry", "Laundry"],
  ["amenity-housekeeping", "Housekeeping"],
  ["amenity-pets", "Pet friendly"],
  ["amenity-beach", "Beach access"],
  ["amenity-deck", "Sun deck"],
  ["amenity-shopping", "Retail"],
  ["amenity-medical", "Medical centre"],
  ["amenity-school", "School nearby"],
  ["amenity-sea-view", "Sea view"],
  ["spec-area", "Area"],
  ["spec-bed", "Bed"],
  ["spec-building", "Building"],
  ["spec-key", "Key"],
  ["spec-eye", "View"],
  ["spec-brush", "Furnishing"],
  ["spec-car", "Parking"],
].map(([file, label]) => ({ label, url: `${DIR}/${file}.svg` }));

// Site-relative paths only resolve on the website, so preview them from there.
export const iconPreviewUrl = (url = "") =>
  url.startsWith("/") ? `${web_url}${url}` : url;
